import type { CfdReferenceQuote } from '../constants/listedCfdReferenceQuotes';

interface ListedCfdQuoteNoticeProps {
  quoteAvailable: boolean;
  referenceQuote: CfdReferenceQuote | null;
}

export default function ListedCfdQuoteNotice({ quoteAvailable, referenceQuote }: ListedCfdQuoteNoticeProps) {

  if (quoteAvailable) {
    return <p className="text-xs text-slate-600">USD CFD prices. 1 lot = 1 unit of the underlying.</p>;
  }

  if (!referenceQuote) {
    return <p className="text-xs text-slate-600">Trading unavailable: waiting for a current market quote.</p>;
  }

  return (
    <p className="text-xs text-slate-600">
      Reference price: <strong>${referenceQuote.price.toFixed(2)} USD</strong>
    </p>
  );
}
